__turbopack_context__.v({
  "confirmation": "order-summary-module-scss-module__41rrfG__confirmation",
  "currencyLabel": "order-summary-module-scss-module__41rrfG__currencyLabel",
  "discount": "order-summary-module-scss-module__41rrfG__discount",
  "divider": "order-summary-module-scss-module__41rrfG__divider",
  "greenLine": "order-summary-module-scss-module__41rrfG__greenLine",
  "icon-american-express": "order-summary-module-scss-module__41rrfG__icon-american-express",
  "icon-arrow": "order-summary-module-scss-module__41rrfG__icon-arrow",
  "icon-chat": "order-summary-module-scss-module__41rrfG__icon-chat",
  "icon-cross": "order-summary-module-scss-module__41rrfG__icon-cross",
  "icon-discover": "order-summary-module-scss-module__41rrfG__icon-discover",
  "icon-mastercard": "order-summary-module-scss-module__41rrfG__icon-mastercard",
  "icon-visa": "order-summary-module-scss-module__41rrfG__icon-visa",
  "label": "order-summary-module-scss-module__41rrfG__label",
  "location": "order-summary-module-scss-module__41rrfG__location",
  "orderSummaryDetails": "order-summary-module-scss-module__41rrfG__orderSummaryDetails",
  "orderSummaryLines": "order-summary-module-scss-module__41rrfG__orderSummaryLines",
  "orderSummaryWrapper": "order-summary-module-scss-module__41rrfG__orderSummaryWrapper",
  "phone": "order-summary-module-scss-module__41rrfG__phone",
  "progressiveDisclaimer": "order-summary-module-scss-module__41rrfG__progressiveDisclaimer",
  "progressiveSubmitWrapper": "order-summary-module-scss-module__41rrfG__progressiveSubmitWrapper",
  "progressiveSummary": "order-summary-module-scss-module__41rrfG__progressiveSummary",
  "progressiveTotal": "order-summary-module-scss-module__41rrfG__progressiveTotal",
  "total": "order-summary-module-scss-module__41rrfG__total",
  "trade-mark": "order-summary-module-scss-module__41rrfG__trade-mark",
  "value": "order-summary-module-scss-module__41rrfG__value",
});
